import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import {
	FieldConfiguration,
	GroupFieldConfiguration,
	LookupFieldConfiguration,
} from '../../../api/ConfigApi';
import {
	FieldGroupCreateRequest,
	FieldGroupsByLocatorMap,
	FieldValuesMap,
} from '../../../types/policy';
import FieldLabel from '../../fields/FieldLabel';
// import { FieldValuesMap } from '../../../types/policy';
import GroupFieldReviewChanges from './GroupFieldReviewChanges';
import LookupField from './LookupField';
import ReactSelect from './ReactSelect';

interface Props {
	field: FieldConfiguration;
	value?: any;
	fieldGroupsByLocator?: FieldGroupsByLocatorMap;
	allValues: FieldValuesMap;
	currentFieldValues?: FieldValuesMap; // current field values are the pending changes that the user is making
	addFieldGroups?: FieldGroupCreateRequest[]; // endorsement add new field groups array
	groupIndex?: string; // for group field unique keys
}

const useStyles = makeStyles((theme) => ({
	disabledInput: {
		'& .MuiInputBase-root.Mui-disabled': {
			color: 'rgba(0, 0, 0, 0.54)',
		},
	},
}));

// Field component for review changes page
const FieldReadOnly = (props: Props) => {
	const classes = useStyles();
	const { field, value, addFieldGroups, groupIndex, currentFieldValues } =
		props;

	const style = { width: '100%' };

	switch (field.type) {
		case 'string':
			return (
				<FormControl style={style}>
					<FieldLabel required={false} title={field.title} />
					<TextField
						className={classes.disabledInput}
						id={`${field.name}-${groupIndex}`}
						value={value}
						disabled
					/>
				</FormControl>
			);
		case 'number':
			return (
				<FormControl style={style}>
					<FieldLabel required={false} title={field.title} />
					<TextField
						className={classes.disabledInput}
						id={`${field.name}-${groupIndex}`}
						value={value}
						type='number'
						disabled
					/>
				</FormControl>
			);
		// case 'date':
		// 	return <DateField
		// 		field={field}
		// 		value={value}
		// 		editing={editing}
		// 		userHasWriteAccess={userHasWriteAccess}
		// 	/>;
		case 'select':
			return (
				<FormControl style={style}>
					<FieldLabel required={false} title={field.title} />
					<ReactSelect
						className={classes.disabledInput}
						id={`${field.name}-${groupIndex}`}
						options={field.values.map((op) => ({ value: op, label: op }))}
						value={{ value, label: value }}
						isDisabled
						onChange={null}
					/>
				</FormControl>
			);
		case 'email':
			return (
				<FormControl style={style}>
					<FieldLabel required={false} title={field.title} />
					<TextField
						className={classes.disabledInput}
						id={`${field.name}-${groupIndex}`}
						value={value}
						disabled
					/>
				</FormControl>
			);
		// case 'media':
		// 	return <MediaField
		// 		field={field}
		// 		value={value}
		// 		editing={editing}
		// 		userHasWriteAccess={userHasWriteAccess}
		// 		mediaHandler={props.mediaHandler}
		// 	/>;
		case 'group':
			return (
				<GroupFieldReviewChanges
					field={field as GroupFieldConfiguration}
					fieldGroupLocators={value}
					fieldGroupsByLocator={props.fieldGroupsByLocator}
					// mediaHandler={props.mediaHandler}
					addFieldGroups={addFieldGroups}
					currentFieldValues={currentFieldValues}
				/>
			);
		case 'lookup':
			return (
				<LookupField
					field={field as LookupFieldConfiguration}
					value={value}
					allValues={props.allValues}
					style={style}
					readOnly
				/>
			);
		default:
			return (
				<FormControl style={style}>
					<FieldLabel required={false} title={field.title} />
					<TextField className={classes.disabledInput} value={value} disabled />
				</FormControl>
			);
	}
};

export default FieldReadOnly;
